import { createSelector } from '@reduxjs/toolkit';

export const getLang = ()=> {
    return createSelector(
        (state) => state.lang,
        (state) => state
    )
}